import React from 'react';
import Header from './Header';
import LeftContent from './LeftContent';
import Header2 from './Header2';

function ActualitéEtudiant() {
  return (
    <>
      <Header />
      <div style={{ backgroundColor: 'orange', height: '8px' }}></div>
      <Header2 />
      <LeftContent/>
    </>
  );
}

export default ActualitéEtudiant;
